import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";

export default function () {
    return (
        <Box display="flex" justifyContent="center" mt={20}>
            <CircularProgress/>
        </Box>
    );
}